import { Scissors, Instagram, ArrowUp } from 'lucide-react'

const quickLinks = [
  { href: '#hem', label: 'Hem' },
  { href: '#tjanster', label: 'Tjänster' },
  { href: '#om-oss', label: 'Om Oss' },
  { href: '#galleri', label: 'Galleri' },
  { href: '#kontakt', label: 'Kontakt' },
]

const services = [
  'Damklippning',
  'Herrklippning',
  'Färgning',
  'Slingor',
  'Keratin',
  'Styling',
]

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <footer className="relative bg-dark-900 border-t border-white/10">
      {/* Main Footer */}
      <div className="w-full px-4 sm:px-6 lg:px-12 xl:px-20 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <a href="#hem" onClick={(e) => { e.preventDefault(); scrollToTop() }} className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-gold-400 to-gold-600 flex items-center justify-center overflow-hidden">
                {/* Logo image - lägg till logo.jpg i public-mappen */}
                <img
                  src="/logo.jpg"
                  alt="VK Studio"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                    (e.currentTarget.parentElement?.querySelector('.fallback-icon') as HTMLElement).style.display = 'flex';
                  }}
                />
                <div className="fallback-icon w-full h-full items-center justify-center" style={{ display: 'none' }}>
                  <Scissors className="w-5 h-5 text-dark-900" />
                </div>
              </div>
              <span className="font-display text-xl font-semibold text-white tracking-wide">
                VK<span className="text-gold-400">.</span>Studio
              </span>
            </a>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Din lokala frisör i Landskrona med fokus på kvalitet,
              personlig service och ett resultat du älskar.<br /><br />
              Säbygatan 15, 261 33 Landskrona<br />
              Tel: 076-653 46 12
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/vkstudio.23/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-dark-700 flex items-center justify-center text-gray-400 hover:text-gold-400 hover:bg-dark-600 transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-lg font-semibold text-white mb-4">Snabblänkar</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault()
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' })
                    }}
                    className="text-gray-400 hover:text-gold-400 transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display text-lg font-semibold text-white mb-4">Våra Tjänster</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <a
                    href="#tjanster"
                    onClick={(e) => {
                      e.preventDefault()
                      document.querySelector('#tjanster')?.scrollIntoView({ behavior: 'smooth' })
                    }}
                    className="text-gray-400 hover:text-gold-400 transition-colors text-sm"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 className="font-display text-lg font-semibold text-white mb-4">Redo för en förändring?</h4>
            <p className="text-gray-400 text-sm mb-4">
              Boka din tid idag och ta det första steget mot ditt drömhår.
            </p>
            <a
              href="https://www.bokadirekt.se/places/vk-studio-54503"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-gold-500 to-gold-600 text-dark-900 font-semibold rounded-full hover:from-gold-400 hover:to-gold-500 transition-all text-sm"
            >
              Boka nu
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="w-full px-4 sm:px-6 lg:px-12 xl:px-20 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} VK Studio. Alla rättigheter förbehållna.
            </p>
            <button
              onClick={scrollToTop}
              className="flex items-center gap-2 text-gray-400 hover:text-gold-400 transition-colors text-sm group"
            >
              Till toppen
              <div className="w-8 h-8 rounded-full bg-dark-700 flex items-center justify-center group-hover:bg-dark-600 transition-colors">
                <ArrowUp className="w-4 h-4" />
              </div>
            </button>
          </div>
        </div>
      </div>
    </footer>
  )
}
